import { datadogRum } from '@datadog/browser-rum';

const initializeDatadogRum = () => {
  const rum_application_id = '198ae352-1491-4688-9aa3-cc368dcc660a';
  const rum_client_token = 'pubfc865538b871ed956258090f47d8faaa';
  const rum_version = __APP_VERSION__;
  const rum_service = 'wave-crm';
  const rum_site = 'us3.datadoghq.com';
  const rum_env = import.meta.env.VITE_ENV as string;

  datadogRum.init({
    applicationId: rum_application_id,
    clientToken: rum_client_token,
    service: rum_service,
    version: rum_version,
    site: rum_site,
    env: rum_env,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'allow',
    trackUserInteractions: true,
    sessionSampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
  });

  datadogRum.startSessionReplayRecording();
};

export default initializeDatadogRum;
